import { Component } from '@angular/core';

@Component({
  selector: 'app-reseller-admin',
  templateUrl: './reseller-admin.component.html',
  styleUrls: ['./reseller-admin.component.css']
})
export class ResellerAdminComponent  {}
